import React from "react";
import OPOnlineIframe from "../../../iframe-component/operation-online/OPOnIframe";

const AddOnlineMerchant = () => {
  return <OPOnlineIframe path="/online-pay/merchant/create" />;
};

export default React.memo(AddOnlineMerchant);
